// extracted by mini-css-extract-plugin
module.exports = {"SelfServicePage":"SelfServicePage_SelfServicePage__15yI0"};